import { render, staticRenderFns } from "./basicSetting.vue?vue&type=template&id=3ac44085&scoped=true"
import script from "./basicSetting.vue?vue&type=script&lang=js"
export * from "./basicSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac44085",
  null
  
)

export default component.exports